import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../components/InputFields/TextInput';
import TransferList from '../../components/InputFields/TransferList';
import { assignUserToOrg, getStaffs, getStaffsById } from '../../api/User';
import { decryptData } from '../../utils/helper';
import { failed, success } from '../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { getClinicsByOrgId } from '../../api/orgnizations';
import MultiSelectWithoutFormik from '../../components/InputFields/MultiSelectWithoutFormik';

const AssignUserModal = ({ setshowAssignUserModal, setGetUpdatedStaff, orgId, alreadyAssignedUserList = [] , refetch, editData, setIsEditData}) => {
  let token = useSelector(state => state.userReducer.token);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [clinicData, setClinicData] = useState([]);
  const [AssinedClinic, setAssinedClinic] = useState([]);
  const [errors, setErrors] = useState({user : "", defaultBranch : "", hospitalAccess : ""});
  const [Values, setValues] = useState({
    existingUserId: null,
    hospitalAccess: [],
    defaultLogInClinic: ""
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    let res;
    try {
      if(Values.existingUserId == ""){
        setErrors({...errors, user: "Required field"});
        return true;
      }else if(Values.defaultLogInClinic == ""){
        setErrors({...errors, defaultBranch: "Required field"});
        return true;
      }else if(Values.hospitalAccess.length <= 0){
        setErrors({...errors, hospitalAccess: "Required field"});
        return true;
      }
      setIsLoading(true);
      const payload = { ...Values,existingUserId:Values.existingUserId.value, orgId: orgId ,isEdit : editData?._id ? true : false};
      res = await assignUserToOrg({ values: payload, dispatch, token });
      if (res?.status == "SUCCESS") {
        await refetch();
        setIsLoading(false);
        success(res?.message);
        setshowAssignUserModal(false);
        setGetUpdatedStaff(res);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
      localStorage.removeItem("addAssignUser");
      setIsEditData({});
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };
  const getUser = async () => {
    let res;
    try {
      setIsLoading(true);
    //   setSearch(searchKey);
      res = await getStaffsById({ dispatch, token, userId: editData?._id });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        const filteredOrganization = responseData?.organizations?.find(
          (org) => org.organizationId === orgId // Replace OrgId with the actual organizationId you're comparing
        );
        const assignedClinics = filteredOrganization?.clinicId?.map((clinicId) =>
        clinicData.find((clinic) => clinic?.value === clinicId)
        ).filter(Boolean);
        setAssinedClinic(assignedClinics?.length > 0 ? assignedClinics : []);
        const user = userList.find(user => user.value === responseData?._id);
        setValues((previous) => ({
          ...previous,
          existingUserId: responseData ? user : "",
          hospitalAccess: filteredOrganization ? filteredOrganization.clinicId : [],
          defaultLogInClinic : filteredOrganization?.defaultClinic ? filteredOrganization?.defaultClinic : ""
        }));
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const getSelectedClinicToAssign = (data) => {
    const uniqueData = Array.from(new Set(data.map(item => item.value))).map(value => {
      return data.find(item => item.value === value);
    });
    setAssinedClinic(uniqueData);
    setValues((prevValues) => ({
      ...prevValues,
      hospitalAccess: uniqueData.map(obj => obj.value)
    }));
  };

  const getUsersList = async (page = 1, limit = 10, searchKey = "") => {
    let res;
    try {
      res = await getStaffs({ dispatch, token, page, limit, searchKey });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setUserList(
          responseData?.items
            .filter((item) => item?.active !== false)
            .filter((item) => !alreadyAssignedUserList.includes(item?._id))
            .filter((item) =>
              item?.roleDetails?.some(role =>
                role.portalLayout === "Organization" && role.active
              )
            )
            .map((obj) => ({
              label: obj?.firstName + " " + obj?.lastName,
              value: obj?._id
            }))
        );
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  const getClinicList = async (page = 1, limit = 10, searchKey = "") => {
    let res = "";
    try {
      setIsLoading(true);
      res = await getClinicsByOrgId({
        dispatch,
        token,
        page,
        limit,
        searchKey,
        orgId: orgId
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setClinicData(responseData?.items?.filter((item)=> item.active !==false).map((obj) => {
          return {
            label: obj?.name,
            value: obj?._id
          };
        }));
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUsersList();
    getClinicList();
  }, []);

  useEffect(()=>{
    if(editData?._id && clinicData.length > 0){
      getUser();
    }
  },[editData,clinicData,userList]);

  const handleUserSearch=(e, newInputValue, reason)=>{
    if(reason == "input"){
      getUsersList(1, 10, e.target.value);
    }
  };
  useEffect(() => {
    if (setshowAssignUserModal) {
      const modalBody = document.querySelector('.assign_modal_body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }
  }, [setshowAssignUserModal]);

  return (
    <Fragment>
      <Modal isOpen={setshowAssignUserModal} toggle={()=>{setshowAssignUserModal();}} size="xl" className='user_modal_block'>
        <ModalHeader toggle={setshowAssignUserModal} className="assign_blk">{editData?._id ? "Edit User Access" : "Add User Access"}</ModalHeader>
        <Form onSubmit={handleSubmit}>
        <ModalBody className="assign_modal_body">
        {isLoading ? <Loader /> : null}
          <div className="organization_form_block organization_blk organization_modal">
            <div className="d-flex gap-4 px-4">
              <div className="forms_block">
                  <Row>
                    <Col lg={12} className="location_block">
                    <MultiSelectWithoutFormik
                        keyField="email"
                        label="Select User"
                        options={userList}
                        placeholder="Select User"
                        onChange={(selectedOption) =>
                          setValues({
                            ...Values,
                            existingUserId: selectedOption
                          })
                        }
                        handleInput={(e, newInputValue, reason)=> handleUserSearch(e, newInputValue, reason)}
                        value={Values?.existingUserId}
                        disabled={editData?._id ? true : false}
                        multiple={false}
                        required={true}
                      />
                      <span style={{color : "red"}}>{errors.user}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12} className='mb-3'>
                      {clinicData.length > 0 ? <TransferList getSelectedClinicToAssign={getSelectedClinicToAssign} clinicList={clinicData} selectedClinics={Values.hospitalAccess}/> : <span style={{color : "red"}}>{`Clinics Not assigned yet`}</span>}
                      <span style={{color : "red"}}>{errors.hospitalAccess}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"email"}
                        label="Default Branch"
                        type="select"
                        options={AssinedClinic}
                        value={Values?.defaultLogInClinic}
                        onChange={(e) => setValues({ ...Values, defaultLogInClinic: e.target.value })}
                      />
                      <span style={{color : "red"}}>{errors.defaultBranch}</span>
                    </Col>
                  </Row>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="p-0 mt-3">
          <div className="d-flex justify-content-center gap-5 mb-4">
            <button className="save_btn" onClick={setshowAssignUserModal}>Close</button>
            <button className="save_btn second" type="submit">Save</button>
          </div>
        </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AssignUserModal;
